import angular from 'angular';

module.exports = angular.module('market.routes.vendor_help.media', [])
.config(function($stateProvider) {
  $stateProvider.state('vendor_help.media', {
    url: '/media',
    template: require('./media.jade')(),
  });
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/routes/vendor-help/media.js
 **/